import * as types from "./actionTypes";

export const applyForJob = (jobId) => ({
  type: types.APPLY_FOR_JOB,
  jobId,
});

export const applySetIsLoading = (isLoading) => ({
  type: types.APPLY_API_LOADING,
  payload: isLoading,
});

export const applySetError = ({ error }) => ({
  type: types.APPLY_API_ERROR,
  payload: error,
});

export const applySuccess = () => ({
  type: types.APPLY_API_SUCCESS,
});
